function HelpDesk({ message, message2 }) {
  return (
    <div className="p-6 md:w-1/3 md:h-48">
      <h2 className="text-3xl text-center mt-4 mx-auto text-neutral-700">
        Asistente
      </h2>
      {message}
      <h2 className="text-3xl text-center mt-6 md:mt-12 md:mb-4 mx-auto text-neutral-700">
        Guias <span className="font-bold">de Apoyo</span>
      </h2>
      <div className="overflow-hidden mt-2">{message2}</div>
    </div>
  );
}

export default HelpDesk;
